<template lang="html">
  <masked-input
    type="text"
    class="text-right form-control input-currency"
    :class="['is-' + state]"
    :placeholder="placeholder"
    v-model="valueMask"
    @change="callChange"
    @keyup="callKeyUp"
    :mask="numberMask"
    :guide="true"
  ></masked-input>
</template>

<script>
import MaskedInput from 'vue-text-mask';
import CurrencyMask from '_common/mixins/CurrencyMask';

export default {
  name: 'InputCurrency',
  components: {
    MaskedInput,
  },
  mixins: [CurrencyMask],
  props: {
    placeholder: {
      type: String,
      default: 'Total',
    },
    model: {
      required: true,
      default: null,
    },
    modelIndex: {
      required: true,
      default: null,
    },
    state: {
      type: String,
      default: null,
    },
    onChange: {
      type: Function,
      default: () => {},
    },
    onKeyup: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      valueMask: '0,00',
    };
  },
  watch: {
    model: {
      handler(value) {
        this.valueMask = this.addDecimalMask(value[this.modelIndex]);
      },
      deep: true,
    },
  },
  methods: {
    callChange() {
      this.model[this.modelIndex] = this.removeDecimalMask(this.valueMask);
      this.onChange(this.model);
    },
    callKeyUp() {
      this.onKeyup(this.model);
    },
  },
  mounted() {
    this.valueMask = this.addDecimalMask(this.model[this.modelIndex]);
  },
};
</script>

<style lang="scss">
.input-group {
  .form-control.input-currency {
    border-top-right-radius: 0.25rem;
    border-bottom-right-radius: 0.25rem;
  }
}
</style>
